import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import WheelPage from '../views/WheelPage.vue'
import WinnerPage from '../views/WinnerPage.vue'
import Start from '../views/Start.vue'
import Info from '../views/Info.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/wheelpage/',
    name: 'WheelPage',
    props: true,
    component: WheelPage
  },
  {
    path: '/winnerpage/',
    name: 'WinnerPage',
    props: true,
    component: WinnerPage
  },
  {
    path: '/s/',
    name: 'Start',
    component: Start
  },
  {
    path: '/info/',
    name: 'Info',
    props: true,
    component: Info
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
